<template>
  <div class="home">
      <div class="bCon">
          <banner-Component></banner-Component>
      </div>

      <foot-Component class="foot wow fadeIn" ></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import footComponent from '../components/foot'
export default {
  name: 'home',
    data(){
      return{
          scrollbar:''
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {

        });
    },
  components:{bannerComponent,footComponent}
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
    animation: run5 1s linear forwards;
    @keyframes run5 {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
    .foot{
      animation-duration: 5s;
    }
  @keyframes transition1 {
    0% {
      transform: translate(-100px,100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px,-100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
        clip-path: polygon(100% 0, 99% 50%, 50% 99%,100% 50%);
        opacity: 0;
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        opacity: 1;
    }
  }

  @media screen  and (min-width: 2200px){

  }
  @media screen and (max-width: 1440px){
  .main{
   .about{
       width:90%;
       .ln{
           width:100%;
       }
   }
  }
  }
  @media screen and (max-width: 1000px){
      .main{
          .about{
              .content{
                  width:100%;
                  flex-direction: column;
                  .left,.right{
                      width:100%;
                      margin-left: 0;
                     position: static;
                  }
                  .left{
                      .t1{
                          p:nth-child(1){
                              font-size: 24px;
                          }
                      }
                  }
              }
              .ln{
                  .allItems{
                      flex-wrap: wrap;
                      .item{
                          width:33%;
                      }
                  }
              }
          }
      }
  }
}
</style>
